import { getLimitedValue } from '../../../split-panel/utils/size-utils';
import { useKeyboardEvents } from '../../utils/use-keyboard-events';
import { usePointerEvents } from '../../utils/use-pointer-events';
export function useResize({ currentWidth, minWidth, maxWidth, panelRef, handleRef, onResize, position }) {
    const onResizeHandler = (newWidth) => {
        const size = getLimitedValue(minWidth, newWidth, maxWidth);
        if (maxWidth >= minWidth) {
            onResize(size);
        }
    };
    const sizeControlProps = {
        position: position !== null && position !== void 0 ? position : 'side',
        panelRef,
        handleRef,
        onResize: onResizeHandler,
    };
    const clampedWidth = getLimitedValue(minWidth, currentWidth, maxWidth);
    const relativeSize = ((clampedWidth - minWidth) / (maxWidth - minWidth)) * 100;
    const onPointerDown = usePointerEvents(sizeControlProps);
    const { onKeyDown, onDirectionClick } = useKeyboardEvents(sizeControlProps);
    return { onKeyDown, onDirectionClick, onPointerDown, relativeSize };
}
//# sourceMappingURL=use-resize.js.map